import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { companyViewByIdApi, companyViewApi } from '../Utils/Axios';

// Async thunk to fetch all companies
export const fetchCompanies = createAsyncThunk(
  'company/fetchCompanies',
  async (_, { rejectWithValue }) => {
    try {
      const response = await companyViewApi();
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch companies'
      );
    }
  }
);

// Async thunk to fetch company data by ID
export const fetchCompanyById = createAsyncThunk(
  'company/fetchCompanyById',
  async (companyId, { rejectWithValue }) => {
    try {
      const response = await companyViewByIdApi(companyId);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch company data'
      );
    }
  }
);

// Slice
const companySlice = createSlice({
  name: 'company',
  initialState: {
    companyData: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCompanyData: (state) => {
      state.companyData = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchCompanyById
      .addCase(fetchCompanyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyById.fulfilled, (state, action) => {
        state.loading = false;
        state.companyData = action.payload;
      })
      .addCase(fetchCompanyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // fetchCompanies
      .addCase(fetchCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.companyData = action.payload;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCompanyData } = companySlice.actions;
export default companySlice.reducer;
